import React, {
  MouseEvent, useEffect, useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import promoImg1 from 'assets/img/promo-1.png';
import promoImg3 from 'assets/img/promo-3.png';

import s from './PromoBanner.module.scss';

function PromoBanner() {
  const [randomItem, setRandomItem] = useState<JSX.Element | null>(null);
  const { pathname } = useLocation();

  const banner1 = (
    <div
      className={cx(s.Inner, s.InnerType3)}
      style={{ backgroundImage: `url('${promoImg1}')` }}
    >
      <span className={cx(s.Text, s.TextCenter)}>
        Секреты  вкуса  и  приключений!
        <span className={s.TextLink}>
          открыть
        </span>
      </span>
    </div>
  );

  const banner2 = (
    <div
      className={cx(s.Inner, s.InnerType2)}
    >
      <span className={cx(s.Text, s.TextType2)}>
        готовь и читай
      </span>
      <span className={cx(s.Text, s.TextType3)}>
        только бестселлеры
      </span>
      <span className={cx(s.TextLink, s.TextLinkRightSide)}>
        открыть
      </span>
    </div>
  );

  const banner3 = (
    <div
      className={cx(s.Inner, s.InnerType1)}
      style={{ backgroundImage: `url('${promoImg3}')` }}
    >
      <span
        className={cx(s.Text, s.TextType1)}
        style={{ color: 'black' }}
      >
        читать тут
        <div className={s.TextLinkWrap}>
          <span
            className={s.TextLink}
            style={{ color: 'black' }}
          >
            перейти
          </span>
        </div>
      </span>
      <span
        className={cx(s.Text, s.TextType1)}
        style={{ color: 'black' }}
      >
        только бестселлеры
      </span>

    </div>
  );

  const items = [banner1, banner2, banner3];

  useEffect(() => {
    const getRandomItem = () => {
      const shuffledItems = [...items].sort(() => 0.5 - Math.random());
      setRandomItem(shuffledItems[0]);
    };

    getRandomItem();
  }, [pathname]);

  const link = 'http://lk10.life.by/lp/flow/l_premium_smartbooks';

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    window.location.replace(link);
  };

  return (
    <div className={s.PromoBanner}>
      <div onClick={handleClick} aria-hidden="true">
        {randomItem}
      </div>
    </div>
  );
}

export default PromoBanner;
